
module.exports = {

	dayNames: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'],
	dayNamesShort: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
	monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
	monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'],

	"date_to": "bis",

	/* PeopleDisplay */
	"adult": "Erwachsener",
	"adult_plural": "Erwachsene",

	"people": "Person",
	"people_plural": "Personen",

	"child": "Kind",
	"child_plural": "Kinder",

	"anfragen_btn": "anfragen",
	"bucken_btn": "buchen",

	/* DesktopApp */
	"search_btn": "Suchen",
	"calendar_hint": "Klicke zuerst auf den Anreisetag und dann auf den Abreisetag",
}




/** WEBPACK FOOTER **
 ** ../ibe/translation/de.js
 **/